<template>
  <div class="event-overview">
    <div class="row mb-2">
      <div class="col-4 col-attribute">Event ID:</div>
      <div class="col-8 col-value">{{ event.id }}</div>
    </div>
    <div class="row mb-2">
      <div class="col-4 col-attribute">Date/Time:</div>
      <div class="col-8 col-value" v-html="event.dateAndTime"></div>
    </div>
    <div class="row mb-2">
      <div class="col-4 col-attribute">Sponsor:</div>
      <div class="col-8 col-value">{{ event.sponsor_name }}</div>
    </div>
    <div class="row mb-2">
      <div class="col-4 col-attribute">Brand:</div>
      <div class="col-8 col-value">{{ event.brand }}</div>
    </div>
    <div v-if="!!event.contact" class="row mb-2">
      <div class="col-4 col-attribute">Local Contact:</div>
      <div class="col-8 col-value" v-html="localContact"></div>
    </div>
    <div v-if="!hideTrainer" class="row mb-2">
      <div class="col-4 col-attribute">Trainer:</div>
      <div v-if="!!event.course.authorized_training" class="col-8 col-value">
        Authorized Training Certified Trainer
      </div>
      <div v-else class="col-8 col-value" v-html="trainer"></div>
    </div>
    <div v-if="isInPerson" class="row mb-2">
      <div class="col-4 col-attribute">Location:</div>
      <div class="col-8 col-value">
        <span v-html="event.address"></span><br />
        <a
          v-if="!print"
          :href="googleMapsUrl"
          target="_blank"
          class="text-primary"
          >View Map</a
        >
      </div>
    </div>
    <div v-else-if="isVirtual && !!event.can_view_webinar" class="row mb-2">
      <div class="col-4 col-attribute">Webinar Details:</div>
      <div class="col-8 col-value">
        <p v-if="!!event.is_live && !print">
          <a :href="event.webinar_url" target="_blank" class="btn btn-danger"
            >LIVE - Join Now</a
          >
        </p>
        <p v-else-if="!print">
          Use the following link at the appointed time to join the webinar:
          <a :href="event.webinar_url" target="_blank" class="text-primary">{{
            event.webinar_url
          }}</a>
        </p>
        <div v-html="event.webinar_notes"></div>
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-4 col-attribute">Hours:</div>
      <div class="col-8 col-value" v-html="event.hours"></div>
    </div>
    <div class="row mb-2">
      <div class="col-4 col-attribute">Pricing:</div>
      <div class="col-8 col-value" v-html="event.pricing"></div>
    </div>
    <div v-if="!!event.can_take_test && !print" class="row mb-2">
      <div class="col-4 col-attribute">Test:</div>
      <div class="col-8 col-value">
        <a :href="event.test_url" target="_blank" class="text-primary"
          >Take Test</a
        >
      </div>
    </div>
    <div v-if="!!event.can_take_survey && !print" class="row mb-2">
      <div class="col-4 col-attribute">Survey:</div>
      <div class="col-8 col-value">
        <a :href="event.survey_url" target="_blank" class="text-primary"
          >Take Survey</a
        >
      </div>
    </div>
    <div v-if="!!event.notes && !print">
      <hr />
      <h5><strong>Additional Notes:</strong></h5>
      <div v-html="event.notes"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    event: { type: Object, required: true },
    hideTrainer: { type: Boolean, default: false },
    print: { type: Boolean, default: false },
  },
  computed: {
    isInPerson() {
      return !this.event.course || !this.event.course.is_virtual;
    },
    isVirtual() {
      return !!this.event.course && !!this.event.course.is_virtual;
    },
    localContact() {
      var contact = this.event.contact.name;
      if (!!this.event.contact.email) {
        contact = this.print
          ? contact
          : `<a href="mailto:${this.event.contact.email}" class="text-primary">${contact}</a>`;
      }
      contact += `<br>${this.event.contact.company.name}`;
      if (!!this.event.contact.company.phone) {
        contact += `<br>${this.event.contact.company.phone}`;
      }
      return contact;
    },
    trainer() {
      var trainer = "";
      this.event.trainers.forEach((t, i) => {
        if (i > 0) trainer += `<br><br>`;
        if (!this.print) {
          var url = this.route("catalog.trainer", { company: t.company.id });
          trainer += `<a href="${url}" target="_blank" class="text-primary">${t.name}</a>`;
        } else {
          trainer += t.name;
        }
        trainer += `<br>${t.company.name}`;
        if (!!t.company.phone) trainer += `<br>${t.company.phone}`;
      });
      return trainer;
    },
    googleMapsUrl() {
      var address = this.event.address1;
      if (!!this.event.address2) {
        address += ` ${this.event.address2}`;
      }
      if (!!this.event.city && !!this.event.state && !!this.event.zip) {
        address += `, ${this.event.city}, ${this.event.state} ${this.event.zip}`;
      }
      var url = "https://maps.google.com/maps?q=" + encodeURIComponent(address);
      return url;
    },
  },
};
</script>